import React, {FC} from 'react';
import {Product} from '@/_application/modules/products/model/product';
import {HighlightProductItem} from '__generated__/__types__';
import {ProductCard} from '@/_application/modules/products/components/cards/product-card';
import {cn} from '@kidslabs/mario-nextjs-react-ui-core/lib/utils';

interface IProps {
    productItem: HighlightProductItem | Product;
    index: number;
    amountOfHighlightProduct?: number;
}

const HighlightHotNewProductCard: FC<IProps> = ({productItem, index, amountOfHighlightProduct = 2}) => {
    let product: Product | undefined | null;
    let isHighlightProductItem = false;
    let label: string = '';
    let icon: string = '';
    if (productItem.__typename === 'HighlightProductItem') {
        product = productItem.product;
        isHighlightProductItem = true;
        label = productItem.label ?? '';
        icon = productItem.icon ?? '';
    } else {
        product = productItem as Product;
    }

    const highlightProductsIndex = amountOfHighlightProduct > 1 ? [0, 4] : amountOfHighlightProduct === 1 ? [0] : [];

    const isHighlightSlot = highlightProductsIndex.includes(index);

    if (!product) return null;

    return (
        <div
            key={product?.sku ?? 'no-sku'}
            className={cn('w-full', {
                'col-span-3 lg:col-span-2': isHighlightSlot && isHighlightProductItem,
            })}>
            {isHighlightSlot && isHighlightProductItem ? (
                <ProductCard
                    key={product?.sku}
                    product={product}
                    extraIcon={icon}
                    extraText={label}
                    variant={'horizontal'}
                    size={'large'}
                />
            ) : (
                <ProductCard key={product.sku} product={product} size="large" />
            )}
        </div>
    );
};

export default HighlightHotNewProductCard;
